interface PatchOrderItemStageInput {
  itemId: number;
  statusId: number;
  descricao: string;
}

export const patchOrderItemStage = (
  pedido: any,
  { itemId, statusId, descricao }: PatchOrderItemStageInput,
) => {
  const itemIndex = pedido?.itens?.findIndex((it: any) => it.oit_id === itemId) ?? -1;

  if (itemIndex < 0 || !Array.isArray(pedido?.itens)) {
    return null;
  }

  const item = pedido.itens[itemIndex];
  const itemAtualizado = {
    ...item,
    status: {
      ...(item.status ?? {}),
      oit_status_id: statusId,
      descricao,
    },
    __etapa_producao__: statusId,
  };

  return {
    ...pedido,
    itens: [
      ...pedido.itens.slice(0, itemIndex),
      itemAtualizado,
      ...pedido.itens.slice(itemIndex + 1),
    ],
  };
};
